import { notification } from "antd";
// eslint-disable-next-line import/no-extraneous-dependencies
import dayjs from "dayjs";
import { useFormContext } from "react-hook-form";
import { useCoordinator } from "@/shared/lib/hooks";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";
import { useUpdateJournalCommon } from "..";

export const useSaveJournal = ({
  handleClear,
}: {
  handleClear: () => void;
}) => {
  const { titleId } = useCoordinator();
  const { mutateAsync: updateTitleJournal } = useUpdateJournalCommon({
    titleId,
  });
  const { handleSubmit, trigger } = useFormContext();

  const handleSave = handleSubmit(
    async (formData) => {
      try {
        await updateTitleJournal({
          params: { path: { titleId } },
          body: {
            mainJournalNumber: formData.journalnumber || "",
            projectCharacteristics: formData.projectCharacteristics || "",
            constructionStartDate: formData.constructionStartDate
              ? dayjs(formData.constructionStartDate).toISOString()
              : "",
            constructionEndDate: formData.constructionEndDate
              ? dayjs(formData.constructionEndDate).toISOString()
              : "",
            mainJournalStartDate: formData.mainJournalStartDate
              ? dayjs(formData.mainJournalStartDate).toISOString()
              : "",
            mainJournalEndDate: formData.mainJournalEndDate
              ? dayjs(formData.mainJournalEndDate).toISOString()
              : "",
          },
        });

        notification.success({
          message: NOTIFICATION_MESSAGES.SUCCESS, // "Успешно"
          description: NOTIFICATION_MESSAGES.TITLE_SAVED_DESC, // "Титульный лист сохранен"
          placement: "topRight",
        });
        handleClear();
      } catch (error: any) {
        const status = error?.response?.status || error?.status;
        
        if (status === 409) {
          notification.error({
            message: NOTIFICATION_MESSAGES.ERROR, // "Ошибка"
            description: NOTIFICATION_MESSAGES.TITLE_SAVE_VALIDATION_ERROR_DESC, // "Сохранение невозможно, проверьте заполненность полей: ..."
            placement: "topRight",
            duration: 0,
          });
        } else {
          notification.error({
            message: NOTIFICATION_MESSAGES.ERROR, // "Ошибка"
            description: NOTIFICATION_MESSAGES.TITLE_SAVE_VALIDATION_ERROR_DESC, // "Сохранение невозможно, проверьте заполненность полей: ..."
            placement: "topRight",
          });
        }
        throw error;
      }
    },
    async () => {
      if (window.parent !== window) {
        // eslint-disable-next-line no-underscore-dangle, react-compiler/react-compiler
        (window as any).__SKIP_SCROLL_RESTORE__ = true;
      }

      handleClear();
      
      await trigger();
      
      notification.error({
        message: NOTIFICATION_MESSAGES.ERROR, // "Ошибка"
        description: NOTIFICATION_MESSAGES.TITLE_SAVE_VALIDATION_ERROR_DESC, // "Сохранение невозможно, проверьте заполненность полей: ..."
        placement: "topRight",
      });
      
    },
  );

  return { handleSave };
};
